  const _capitalizeWords = string => {
    const sentence = string
    const words = sentence.split(" ");
  
    const allWordsJoined =  words.map((word) => { 
        return word[0].toUpperCase() + word.substring(1); 
    }).join(" ");
    
    return allWordsJoined;
  }
  
  
  export { _capitalizeWords };